import React from 'react';

import {
  createMuiTheme,
  createStyles,
  withStyles,
  WithStyles,
  Theme,
  ThemeProvider,
  CssBaseline,
} from '@material-ui/core';

import { Helmet } from 'react-helmet';

import { isNil } from 'lodash-es';

import Dataset from '../dataset';
import Header from '../../components/header';
import Footer from '../../components/footer';
import { IBranding } from '../../types/branding';

const theme = createMuiTheme();

const styles = (_theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      flexGrow: 1,
      position: 'relative',
      width: '100%',
      maxWidth: '60rem',
      left: '50%',
      transform: 'translateX(-50%)',
      marginTop: '0.5rem',
    },
    footer: {},
  });

interface Props extends WithStyles<typeof styles> {}

interface State {
  branding?: IBranding;
}

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    fetch(`${process.env.PUBLIC_URL}/deployment/branding.json`)
      .then((res) => res.json())
      .then((branding: IBranding) => {
        const state = {
          branding: {
            ...branding,
            rightLogo: `${process.env.PUBLIC_URL}/deployment/${branding.rightLogo}`,
            favIcon: `${process.env.PUBLIC_URL}/deployment/${branding.favIcon}`,
          },
        };

        if (!isNil(branding.leftLogo)) {
          state.branding.leftLogo = `${process.env.PUBLIC_URL}/deployment/${branding.leftLogo}`;
        }

        this.setState(state);
      });
  }

  render() {
    const { classes } = this.props;
    const { branding } = this.state;

    if (!branding) {
      return null;
    }

    return (
      <React.Fragment>
        <Helmet>
          <link rel="icon" href={branding.favIcon} />
          <title>{branding.title}</title>
          <meta name="description" content={branding.title} />
        </Helmet>

        <ThemeProvider theme={theme}>
          <div className={classes.root}>
            <CssBaseline />
            <Header
              leftLogo={branding.leftLogo}
              rightLogo={branding.rightLogo}
            />
            <div className={classes.content}>
              <Dataset />
            </div>
            <Footer license={branding.license} privacy={branding.privacy} />
          </div>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(App);
